export const DAY_WITHOUT_DATA = 500;

export const MIN_RANK_POSITION = 1;
export const MAX_RANK_POSITION = 30;
export const NOT_RANK_POSITION = MAX_RANK_POSITION + 1;
export const NOT_RANKED_SIGN = `>${MAX_RANK_POSITION}`;
